import { render } from "./MultiplePictureChoiceButton.vue?vue&type=template&id=77215c36&scoped=true&ts=true"
import script from "./MultiplePictureChoiceButton.vue?vue&type=script&lang=ts"
export * from "./MultiplePictureChoiceButton.vue?vue&type=script&lang=ts"

import _style_0 from "./MultiplePictureChoiceButton.vue?vue&type=style&index=0&id=77215c36&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-77215c36"]])

export default __exports__